import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterTacheByNamePipe } from 'src/app/shared/pipes/filter-tache-by-name/filter-tache-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { TacheModalDetailComponent } from './modal/tache-modal-detail/tache-modal-detail.component';
import { TacheModalAjoutComponent } from './modal/tache-modal-ajout/tache-modal-ajout.component';
import { ListTacheComponent } from './list-tache/list-tache.component';

@NgModule({
	declarations: [
		ListTacheComponent,
		TacheModalDetailComponent,
		TacheModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterTacheByNamePipe]
})

export class TacheModule {}
